import React from 'react';
import AdminTokens from 'src/components/AdminTokens';
import ResponsiveWrapper from 'src/components/ResponsiveWrapper';

const ProxyTokens = () => {
    return (
        <ResponsiveWrapper>
            <AdminTokens />
        </ResponsiveWrapper>
    );
};
 export default ProxyTokens;
